var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylistsN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_10069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.1034,
    cy: 25.1034,
    r: 25.1034,
    fill: "url(#paint0_linear_752_10069)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_752_10069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7826 12.4043L14.2185 12.9962C14.0456 13.0146 13.9146 13.1602 13.9146 13.3341V17.8814C13.695 17.7676 13.4458 17.7028 13.1816 17.7028C12.3003 17.7028 11.586 18.4171 11.586 19.2982C11.586 20.1793 12.3003 20.8938 13.1814 20.8938C14.0625 20.8938 14.777 20.1793 14.777 19.2982V15.5588C14.777 15.5342 14.7956 15.5134 14.8201 15.5107L19.2425 15.0404C19.2711 15.0373 19.2959 15.0598 19.2959 15.0885V17.0706C19.0764 16.9568 18.8273 16.892 18.5628 16.892C17.6817 16.892 16.9674 17.6065 16.9674 18.4876C16.9674 19.3687 17.6817 20.083 18.5628 20.083C19.444 20.083 20.1584 19.3687 20.1584 18.4876V12.7421C20.1584 12.5404 19.9835 12.383 19.7826 12.4043Z",
    fill: "#F16480",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1035 16.2324C18.4352 16.2324 13.0292 21.6382 13.0292 28.3071C13.0292 30.7071 13.7297 32.9433 14.9369 34.823C17.4145 37.6485 21.0504 39.433 25.1035 39.433C29.1567 39.433 32.7925 37.6485 35.2701 34.823C36.4773 32.9433 37.1778 30.7071 37.1778 28.3071C37.1778 21.6382 31.7718 16.2324 25.1035 16.2324Z",
    fill: "url(#paint1_linear_752_10069)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1035 38.6659C19.3918 38.6659 14.7451 34.0191 14.7451 28.3074C14.7451 22.596 19.3918 17.9492 25.1035 17.9492C30.8152 17.9492 35.4619 22.596 35.4619 28.3074C35.4619 34.0191 30.8152 38.6659 25.1035 38.6659ZM25.1035 18.7412C19.8287 18.7412 15.5371 23.0326 15.5371 28.3074C15.5371 33.5824 19.8287 37.8738 25.1035 37.8738C30.3783 37.8738 34.6699 33.5824 34.6699 28.3074C34.6699 23.0326 30.3783 18.7412 25.1035 18.7412Z",
    fill: "#D2536C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1035 36.5511C20.5566 36.5511 16.8571 32.8519 16.8571 28.3047C16.8571 23.7578 20.5566 20.0586 25.1035 20.0586C29.6504 20.0586 33.3498 23.7578 33.3498 28.3047C33.3498 32.8519 29.6504 36.5511 25.1035 36.5511ZM25.1035 20.8506C20.9932 20.8506 17.6492 24.1945 17.6492 28.3047C17.6492 32.4152 20.9932 35.7591 25.1035 35.7591C29.2138 35.7591 32.5578 32.4152 32.5578 28.3047C32.5578 24.1945 29.2138 20.8506 25.1035 20.8506Z",
    fill: "#D2536C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0484 22.5391C21.8844 22.5391 19.3103 25.1131 19.3103 28.2775C19.3103 31.4415 21.8844 34.0156 25.0484 34.0156C28.2123 34.0156 30.7864 31.4415 30.7864 28.2775C30.7864 25.1131 28.2123 22.5391 25.0484 22.5391Z",
    fill: "#FDF3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3003 12.4052L29.0414 13.2837C28.785 13.3109 28.5905 13.5273 28.5905 13.7851V20.5344C28.2646 20.3655 27.8948 20.2694 27.5025 20.2694C26.1946 20.2694 25.1343 21.3296 25.1343 22.6376C25.1343 23.9455 26.1946 25.0057 27.5025 25.0057C28.8102 25.0057 29.8706 23.9455 29.8706 22.6376V17.0873C29.8706 17.0506 29.8982 17.0198 29.9347 17.0159L36.4986 16.3179C36.5411 16.3134 36.578 16.3466 36.578 16.3893V19.3311C36.2521 19.1622 35.8823 19.0661 35.49 19.0661C34.1821 19.0661 33.1218 20.1265 33.1218 21.4343C33.1218 22.7422 34.1821 23.8024 35.49 23.8024C36.7979 23.8024 37.858 22.7422 37.858 21.4343V12.9066C37.858 12.6072 37.5984 12.3735 37.3003 12.4052Z",
    fill: "url(#paint2_linear_752_10069)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.1036,
    cy: 28.3178,
    r: 1.93103,
    fill: "url(#paint3_linear_752_10069)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_752_10069",
    x1: 25.1034,
    y1: 0,
    x2: 25.1034,
    y2: 45.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114585,
    stopColor: "#F16480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333339,
    stopColor: "#F16480",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776056,
    stopColor: "#F16480",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_752_10069",
    x1: 25.1035,
    y1: 16.2324,
    x2: 25.1035,
    y2: 39.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78CA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_752_10069",
    x1: 31.4962,
    y1: 12.4023,
    x2: 31.4962,
    y2: 25.0057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4648A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F096B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_752_10069",
    x1: 25.1036,
    y1: 26.3867,
    x2: 25.1036,
    y2: 30.2488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67F96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_10069"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L50 0L50 38.4138C50 44.8127 44.8127 50 38.4138 50L0 50L0 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_752_10069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.0345,
    height: 27.0345,
    fill: "white",
    transform: "translate(11.5863 12.4023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistsN);
export default __webpack_public_path__ + "static/media/playlists-n.a6debb9fd5f353d32ab7be69acdfb150.svg";
export { ForwardRef as ReactComponent };